import { Fragment } from "react";
import type { ArticleBlock } from "@/mocks/articles";

interface ArticleContentProps {
  blocks: ArticleBlock[];
  onImageClick: (src: string) => void;
}

export default function ArticleContent({ blocks, onImageClick }: ArticleContentProps) {
  return (
    <div className="space-y-6">
      {blocks.map((block, index) => {
        if (block.type === "h2") {
          return (
            <h2
              key={index}
              className="font-heading text-xl md:text-2xl font-bold text-foreground-900 pt-4 leading-snug"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote
              key={index}
              className="relative pl-5 md:pl-6 py-2 border-l-4 border-accent-500 bg-accent-50/60 rounded-r-md"
            >
              <p className="font-heading text-base md:text-lg text-foreground-800 leading-relaxed">
                {block.text}
              </p>
            </blockquote>
          );
        }
        if (block.type === "image") {
          return (
            <figure key={index} className="space-y-3">
              <button
                type="button"
                onClick={() => block.src && onImageClick(block.src)}
                className="group block w-full rounded-lg overflow-hidden border border-background-200 cursor-pointer"
              >
                <img
                  src={block.src}
                  alt={block.caption || "文章配图"}
                  title="点击查看大图"
                  className="w-full h-56 md:h-80 object-cover object-top group-hover:scale-[1.02] transition-transform duration-500"
                />
              </button>
              {block.caption && (
                <figcaption className="text-xs text-foreground-500 text-center">
                  {block.caption}
                </figcaption>
              )}
            </figure>
          );
        }
        return (
          <Fragment key={index}>
            <p className="text-[15px] md:text-base text-foreground-700 leading-[1.9]">{block.text}</p>
          </Fragment>
        );
      })}
    </div>
  );
}